module.exports = __webpack_public_path__ + "static/img/pmg_logo_rev.917c0a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pmg_logo_rev.png
// module id = OAxq
// module chunks = 0